import { useQueryClient } from '@tanstack/react-query';
import { useOptimisticMutation, type Variables } from '../../../hooks/use-optimistic-mutation';
import type { ShippingMethodApiBase, ShippingMethodApiResponse } from '../types/shipping-method';
import { QK_LIST_SHIPPING_METHODS } from './use-shipping-methods';
import { useShippingMethodsApi } from './use-shipping-methods-api';

export function useUpdateShippingMethod() {
  const { shippingMethodsApi } = useShippingMethodsApi();
  const queryClient = useQueryClient();

  async function updateMethod({ id, payload }: { id: string; payload: ShippingMethodApiBase }) {
    await shippingMethodsApi.shippingMethod(id).update(payload);
  }

  return useOptimisticMutation<ShippingMethodApiResponse[], Variables<typeof updateMethod>>({
    mutationFn: updateMethod,
    queryKey: QK_LIST_SHIPPING_METHODS(),
    queryClient,
    optimisticUpdate: (prev, { id, payload: newMethod }) =>
      prev?.map((method) =>
        method.id === id
          ? {
              ...method,
              ...newMethod,
              updated_at: new Date().toISOString(),
            }
          : method,
      ) ?? [],
  });
}
